export default "__VITE_PUBLIC_ASSET__e8a95ba4__"